import Logs from './index';

export default {
  path: '/home/logs',
  component: Logs
};
